export const GrainOverlay = () => (
  <div
    aria-hidden="true"
    className="grain pointer-events-none fixed inset-0 z-[60] opacity-[0.07] mix-blend-overlay"
  />
);
